var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 17C34 26.3888 26.3888 34 17 34C7.61118 34 0 26.3888 0 17C0 7.61118 7.61118 0 17 0C26.3888 0 34 7.61118 34 17ZM11.384 15.4427C9.681 16.1863 7.93128 16.9503 6.33126 17.8316C5.4958 18.4433 6.60619 18.876 7.64795 19.2819C7.81355 19.3464 7.97739 19.4102 8.13145 19.474C8.25966 19.5135 8.39 19.555 8.5221 19.597C9.68072 19.9661 10.9726 20.3778 12.0974 19.7586C13.9452 18.6972 15.6889 17.47 17.4313 16.2439C18.0022 15.8421 18.5729 15.4405 19.147 15.0448C19.1739 15.0276 19.2043 15.0079 19.2375 14.9864C19.7266 14.6693 20.8267 13.9562 20.4198 14.9388C19.4576 15.9911 18.4269 16.9226 17.3906 17.8592C16.6922 18.4904 15.9913 19.1239 15.307 19.7983C14.7111 20.2825 14.0922 21.2562 14.7595 21.9343C16.2966 23.0103 17.8576 24.0602 19.4177 25.1095C19.9253 25.4509 20.433 25.7923 20.9396 26.1346C21.7983 26.8201 23.1402 26.2656 23.329 25.1944C23.4129 24.7016 23.4972 24.2088 23.5815 23.7161C24.0473 20.9927 24.5132 18.2684 24.9248 15.5362C24.9808 15.1076 25.0442 14.6791 25.1077 14.2503C25.2614 13.2111 25.4154 12.1707 25.4635 11.1259C25.3396 10.0832 24.0753 10.3125 23.3718 10.5469C19.7556 11.9229 16.1756 13.401 12.6097 14.905C12.2057 15.084 11.7962 15.2627 11.384 15.4427Z",
    fill: "#FEFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.045485453dda89dd090a9d86a214a307.svg";
export { ForwardRef as ReactComponent };